import { render, staticRenderFns } from "./OrderRefundModal.vue?vue&type=template&id=206e6524&scoped=true"
import script from "./OrderRefundModal.vue?vue&type=script&lang=js"
export * from "./OrderRefundModal.vue?vue&type=script&lang=js"
import style0 from "./OrderRefundModal.vue?vue&type=style&index=0&id=206e6524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e6524",
  null
  
)

export default component.exports